import $ from 'jquery'
import axios from 'axios'
import Swiper from 'swiper'

const html = (val) => `${val.map((each) => `
  <li class="m-showcase__item m-searchShowcase__item">
    <a class="m-detailShowcase__itemInner" href="/styles/${each.style_key}/designs/${each.design_id}/preview/">
      <div class="a-card--noShadow m-detailShowcase__surface">
        <span class="a-card--noShadow__inner m-detailShowcase__cardInner">
          <img src="/assets/img/banner/templates/list/${each.image_style_key}_${each.design_id}.png" srcset="/assets/img/banner/templates/list/${each.image_style_key}_${each.design_id}@2x.png 2x" width="${each.width}" height="${each.height}" >
        </span>
      </div>
    </a>
    <div class="m-searchShowcase__item__info">
      ${checkPopular(each.is_popular)}<span class="m-searchShowcase__item__info__title">${each.design_name}</span>
      <div class="a-favorite m-searchShowcase__item__info__fav js-favorite ${checkFavorite(each.favorite)}" data-favorite="${each.style_key}@${each.design_id}"></div>
    </div>
    ${detailLink(each.style_key, each.design_id)}
  </li>
  `).join('')}
`

const posterHtml = (val) => `${val.map((each) => `
  <li class="m-showcase__item m-searchShowcase__item">
    <a class="m-detailShowcase__itemInner" href="/styles/${each.style_key}/designs/${each.design_id}/preview/">
      <div class="a-card--noShadow m-detailShowcase__surface">
        <span class="a-card--noShadow__inner m-detailShowcase__cardInner">
          <img src="/assets/img/banner/templates/list/${each.image_style_key}_${each.design_id}.png" srcset="/assets/img/banner/templates/list/${each.image_style_key}_${each.design_id}@2x.png 2x" width="344" height="344" >
        </span>
      </div>
    </a>
    <div class="m-searchShowcase__item__info">
      ${checkPopular(each.is_popular)}<span class="m-searchShowcase__item__info__title">${each.design_name}</span>
      <div class="a-favorite m-searchShowcase__item__info__fav js-favorite ${checkFavorite(each.favorite)}" data-favorite="${each.style_key}@${each.design_id}"></div>
    </div>
    ${detailLink(each.style_key, each.design_id)}
  </li>
  `).join('')}
`

const sealHtml = (val) => `${val.map((each) => `
  <li class="m-showcase__item m-searchShowcase__sealItem">
    <a class="m-detailShowcase__itemInner" href="/styles/${each.style_key}/designs/${each.design_id}/preview/">
      <div class="a-card--noShadow m-detailShowcase__surface">
        <span class="a-card--noShadow__inner m-detailShowcase__cardInner m-searchShowcase__sealItem__inner">
          <img src="/assets/img/banner/templates/list/${each.image_style_key}_${each.design_id}.png" srcset="/assets/img/banner/templates/list/${each.image_style_key}_${each.design_id}@2x.png 2x" width="${each.width}" height="${each.height}" >
        </span>
      </div>
    </a>
    <div class="m-searchShowcase__item__info">
      ${checkPopular(each.is_popular)}<span class="m-searchShowcase__item__info__title">${each.design_name}</span>
      <div class="a-favorite m-searchShowcase__item__info__fav js-favorite ${checkFavorite(each.favorite)}" data-favorite="${each.style_key}@${each.design_id}"></div>
    </div>
    ${detailLink(each.style_key, each.design_id)}
  </li>
  `).join('')}
`

const checkFavorite = (v) => {
  if (v === '1') {
    return 'is-active'
  }
  return ''
}

const detailLink = (key, id) => {
  if (key !== 'pics' && key !== 'neon' && key !== 'dark') {
    return `<div class="m-searchShowcase__item__link"><a class="a-arrowLinkBule--M" href="/styles/${key}/designs/${id}/">詳細をみる</a></div>`
  }
  return ''
}

const checkPopular = (v) => {
  if (v === '1') {
    return '<img class="m-searchShowcase__item__info__popular" src="/assets/img/icon/icon-popular.svg">'
  }
  return ''
}

function refreshResultView (isAnimate = true) {
  $('.js-DesignsForm').ajaxSubmit({
    url: '',
    dataType: 'json',
    success: (response, statusText) => {
      if (response.categoryKey === 'card') {
        $('.js-ShowCase').html(html(response.designs))
      } else if (response.categoryKey === 'poster') {
        $('.js-ShowCase').html(posterHtml(response.designs))
      } else if (response.categoryKey === 'seal' || response.categoryKey === 'envelope' || response.categoryKey === 'leaflet') {
        $('.js-ShowCase').html(sealHtml(response.designs))
      } else {
        $('.js-ShowCase').html(html(response.designs))
      }
      $('.js-pager').html(response.pager)
      if (isAnimate) {
        $('html, body').animate({scrollTop: $('.js-styleList').offset().top}, 500, 'swing')
      }
      window.Ts.reload()
    }
  })
}

const inputDesignName = () => {
  // Enterキーを抑制
  $('.js-DesignName').on('keydown', '', (e) => {
    if ((e.which && e.which === 13) || (e.keyCode && e.keyCode === 13)) {
      return false
    }
    return true
  })

  let timer
  // フォーカスがある間だけ入力値を監視、変化があればPOSTする
  $('.js-DesignName').on('focus', '', () => {
    $('.js-DesignName').data('past-text', $('.js-DesignName').val())
    timer = setInterval(() => {
      if ($('.js-DesignName').val() !== $('.js-DesignName').data('past-text')) {
        $('.js-DesignName').data('past-text', $('.js-DesignName').val())
        $('.js-pageValue').val('')
        refreshResultView(false)
      }
    }, 2000)
  })

  $('.js-DesignName').on('blur', '', () => {
    clearInterval(timer)
  })
}

const clickSize = () => {
  $('.js-Size').on('click', '', () => {
    $('.js-pageValue').val('')
    refreshResultView()
  })
}

const clickTagPersons = () => {
  $('.js-TagPersons').on('click', '', () => {
    $('.js-pageValue').val('')
    refreshResultView()
  })
}

const clickTagTaste = () => {
  $('.js-TagTaste').on('click', '', () => {
    $('.js-pageValue').val('')
    refreshResultView()
  })
}

const clickTagPicture = () => {
  $('.js-TagPicture').on('click', '', () => {
    $('.js-pageValue').val('')
    refreshResultView()
  })
}

const clickColor = () => {
  $('.js-Color').on('click', () => {
    $('.js-pageValue').val('')
    refreshResultView()
  })
}

const clickFavorite = () => {
  $(document).on('click', '.js-favorite', (e) => {
    let target = $(e.target)
    let designId = $(e.target).data('favorite')
    if (designId !== '') {
      let url = '/api/template_favorite/'
      axios.post(url, {design_id: designId}).then((res) => {
        let json = JSON.parse(JSON.stringify(res.data))
        if (json.status === '1') {
          if (target.hasClass('is-active')) {
            target.removeClass('is-active')
          } else {
            target.addClass('is-active')
          }
        } else {
          target.removeClass('is-active')
        }
      })
    }
    return false
  })
}

const clickPager = () => {
  $(document).on('click', '.js-pager', (e) => {
    if (!$(e.target).hasClass('is-disable')) {
      $('.js-pageValue').val($(e.target).data('page'))
      refreshResultView()
      $('html, body').animate({ scrollTop: $('.js-styleList').offset().top }, 500, 'swing')
    }
  })
}

const slideStartNum = $('.js-designStyle').length - 1

const clickTermPC = () => {
  $(document).on('click', '.js-termName', (e) => {
    let $target
    if ($(e.target).hasClass('js-termName')) {
      $target = $(e.target)
    } else {
      $target = $(e.target).closest('.js-termName')
    }
    const termName = $target.data('term')
    if (!$target.hasClass('is-choice')) {
      $('.js-termName').removeClass('is-choice')
      $('[class*="js-termModal-"]').removeClass('is-choice')
      $target.addClass('is-choice')
      $('.js-termModal-' + termName).addClass('is-choice')
    } else {
      $target.removeClass('is-choice')
      $('.js-termModal-' + termName).removeClass('is-choice')
    }
  })
}

const clickTermSP = () => {
  $(document).on('click', '.js-designTermName', (e) => {
    let $target
    if ($(e.target).hasClass('js-designTermName')) {
      $target = $(e.target)
    } else {
      $target = $(e.target).closest('.js-designTermName')
    }
    const termName = $target.data('term')
    const $modal = $('.js-termModal-' + termName)
    const winWidth = $(window).width()
    const offset = $target.offset()
    const $attach = $('.js-termDescAttach')
    if (!$target.hasClass('is-choice')) {
      $('.js-designTermName').removeClass('is-choice')
      $('[class*="js-termModal-"]').removeClass('is-choice')
      $('.js-termDescAttach').removeClass('is-choice')
      $target.addClass('is-choice')

      if (winWidth - ($modal.width() + offset.left) >= 0) {
        $modal.addClass('is-choice')
          .css({
            top: offset.top + 40 + 'px',
            left: offset.left + 'px',
            right: 'auto'
          })
      } else {
        $modal.addClass('is-choice')
          .css({
            top: offset.top + 40 + 'px',
            left: 'auto',
            right: 0
          })
      }
      console.log($attach.width())
      if (winWidth - (134 + offset.left) >= 0) {
        $attach.css({
          width: 134 + 'px'
        })
      } else {
        $attach.css({
          width: 134 + (winWidth - (134 + offset.left + 2)) + 'px'
        })
      }
      $attach.addClass('is-choice')
        .css({
          top: offset.top + 29 + 'px',
          left: offset.left + 1 + 'px'
        })
    } else {
      $target.removeClass('is-choice')
      $modal.removeClass('is-choice')
      $attach.removeClass('is-choice')
    }
  })
}

const termSlidePaging = () => {
  $(document).on('click', '.js-termPrev, .js-termNext', () => {
    $('.js-designTermName').removeClass('is-choice')
    $('[class*="js-termModal-"]').removeClass('is-choice')
    $('.js-termDescAttach').removeClass('is-choice')
  })
}

$(() => {
  inputDesignName()
  clickSize()
  clickTagPersons()
  clickTagTaste()
  clickTagPicture()
  clickColor()
  clickPager()
  clickFavorite()
  refreshResultView()
  Swiper('.js-designStyleList', {
    loop: true,
    speed: 500,
    slidesPerView: 'auto',
    initialSlide: slideStartNum,
    prevButton: '.js-desigPrev',
    nextButton: '.js-designNext',
    hideOnClick: true
  })
  Swiper('.js-termsList-sp', {
    loop: true,
    speed: 500,
    slidesPerView: 'auto',
    initialSlide: 0,
    prevButton: '.js-termPrev',
    nextButton: '.js-termNext',
    hideOnClick: true
  })
  clickTermPC()
  clickTermSP()
  termSlidePaging()
})



// WEBPACK FOOTER //
// ./src/scripts/page/designs.js